export default __webpack_public_path__ + "static/media/rocky-mountain-elk-foundation.55850711.png";